import helper from '../utils/helper';

export class GridDataAdapter {
    static transform(data, fields) {
        const transformedData = {};

        if (data?.id) {
            transformedData.id = data.id;
        }

        const fieldProcessors = {
            boolean: (field) => {
                return data?.[field.id] === true;
            },
            object: (field) => {
                if (field.cell === 'Upload') {
                    return helper.transformUploadFile(data?.[field.object]);
                }
                return data?.[field.object]?.id || null;
            },
            merchantUpload: (field) =>
                helper.transformUploadFiles(data?.[field.id] || []),
            owner: (field) => {
                const kind = data?.[data.kind];
                return kind?.id || null;
            },
            walletArray: (field) => {
                return data?.[field.id]?.map((wallet) => wallet.walletNumber) || [];
            },
            default: (field) => {
                return field.defaultValue || data?.[field.id] || null;
            }
        };

        fields.forEach((field) => {
            const processor =
                fieldProcessors[field.type] ||
                (field.object
                    ? fieldProcessors['object']
                    : fieldProcessors['default']);
            transformedData[field.id] = processor(field);
        });

        return transformedData;
    }
}
